import { ColumnDef } from '@benzinga/table';
import dayjs from 'dayjs';

import { AmountBags } from './AmountBags';
import { ChamberBadge } from './memberBadges';
import { MemberNameLink, SecurityNameCell, SecurityTickerLink, TableLink } from './TableCells';

export const amountMap = {
  '$1,000,001 - $5,000,000': '$1M - $5M',
  '$1,001 - $15,000': '$1K - $15K',
  '$100,001 - $250,000': '$100K - $250K',
  '$15,001 - $50,000': '$15K - $50K',
  '$25,000,001 - $50,000,000': '$25M - $50M',
  '$250,001 - $500,000': '$250K - $500K',
  '$5,000,001 - $25,000,000': '$5M - $25M',
  '$50,000,000 +': '$50M+',
  '$50,001 - $100,000': '$50K - $100K',
  '$500,001 - $1,000,000': '$500K - $1M',
};

export const TradesColumnsDef = [
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => {
      const { company_name, logo, security, ticker } = data;
      return <SecurityNameCell logo={logo} name={company_name ?? security?.name} ticker={ticker} />;
    },
    field: 'security.name',
    headerName: 'Name',
    sortEnabled: true,
    valueGetter: ({ data }) => {
      return data?.security?.name ?? '';
    },
    width: 150,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <SecurityTickerLink ticker={data.ticker} />,
    field: 'ticker',
    headerName: 'Symbol',
    sortEnabled: true,
    width: 100,
  },
  {
    cellClass: 'security-cell bz-edge-cell',
    cellRenderer: ({ data }) => <AmountBags amount={data.amount} transactionType={data.transaction_type} />,
    field: 'amount',
    headerName: 'Amount',
    sortEnabled: true,
    width: 100,
  },
  {
    cellClass: 'security-cell type',
    field: 'security',
    headerName: 'Type',
    sortEnabled: true,
    valueFormatter: ({ value }) => {
      return value?.type?.toLowerCase();
    },
    width: 100,
  },
  {
    cellClass: 'security-cell bz-edge-cell',
    field: 'transaction_type',
    headerName: 'Transaction',
    sortEnabled: true,
    valueFormatter: ({ value }) => {
      if (!value) return '';
      const isPartial = value.includes('(Partial)');
      const type = value.split(' ')[0];
      return (type === 'P' ? 'Purchase' : 'Sale') + (isPartial ? ' (Partial)' : '');
    },
    width: 100,
  },
  {
    cellClass: 'security-cell bz-edge-cell',
    cellRenderer: ({ data }) => <MemberNameLink name={data?.filer_info?.display_name} />,
    field: 'filer_info.display_name',
    headerName: 'Member',
    sortEnabled: true,
    valueGetter: ({ data }) => {
      return data?.filer_info?.display_name ?? '';
    },
    width: 100,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => (
      <TableLink external href={data.disclosure_url}>
        {dayjs(data.report_date).format('MMM DD, YYYY')}
      </TableLink>
    ),
    field: 'report_date',
    headerName: 'Report Date',
    sortEnabled: true,
    width: 100,
  },
  {
    cellClass: 'security-cell',
    field: 'transaction_date',
    headerName: 'Trade Date',
    sortEnabled: true,
    valueFormatter: ({ value }) => {
      return dayjs(value).format('MMM DD, YYYY');
    },
    width: 100,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <ChamberBadge chamber={data.chamber} />,
    field: 'chamber',
    headerName: 'Chamber',
    sortEnabled: true,
    width: 100,
  },
] as ColumnDef<any>[];
